import React, { useState, useEffect, useRef } from 'react'
import './TabLayout.less'
import {Menu} from "antd";


function TabLayout(props) {
    const [currentId, setCurrentId] = useState("1")
    const [subMenuStyle, setSubMenuStyle] = useState({
        display: "none",
        left: 0,
        top: 0
    })
    const ul = useRef(null)
    let subMenuLi = []

    useEffect(() => {
        updateSelectMenu()
        window.addEventListener("scroll", _disableSubMenu)
        return () => {
            window.removeEventListener("scroll", _disableSubMenu)
        }
    }, [props.history.location.pathname, subMenuStyle, currentId])

    function findTabByPathName() {
        let currentPath = props.history.location.pathname.split("/")[1]
        let tab = props.tabList.find(item => {
            return item.name === currentPath.toString()
        })
        return tab
    }

    function updateSelectMenu() {
        if (subMenuStyle.display === 'block') {
            return;
        }
        let temp = findTabByPathName()
        let ele = subMenuLi[`li_${temp.id}`]
        let widthOffset = getScreenWidth() - getElemWidth(ele)
        let offsetLeft = getOffsetLeft(ele) - widthOffset / 2
        ul.current.scrollLeft = offsetLeft
        setCurrentId(temp.id.toString())
        window.scroll(0, 0)
    }

    function _disableSubMenu() {
        if (subMenuStyle.display !== 'none') {
            setSubMenuStyle(Object.assign({}, subMenuStyle, {
                display: "none"
            }))
        }
    }

    function createTabItem(data) {
        return data.map(item => {
            return <li className={`${setIndicatorStyle(item)}`} key={item.id}
                       tabIndex={item.id} onBlur={_disableSubMenu} ref={ r => {
                           subMenuLi[`li_${item.id}`] = r
            }}>
                <a href="#" onClick={() => {
                    handleClickTab(item)
                }}>
                    <span>{item.title}</span>
                </a>
                {
                    item.tItems && <Menu className="tab_menu" mode="vertical"
                                         style={subMenuStyle}>
                        {
                            createMenuItem(item)
                        }
                    </Menu>
                }
            </li>
        })
    }

    function setIndicatorStyle(item) {
        return currentId === item.id.toString() ? "tab_actived" : ""
    }


    function createMenuItem(data) {
        return data.tItems.map(item => {
            return <Menu.Item key={item.id.toString()} onMouseDown={() => handleClickMenu(data, item.tRoute)}>
                {item.title}
            </Menu.Item>

        })
    }

    function handleClickMenu(item, route) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        setCurrentId(item.id.toString())
        setSubMenuStyle(Object.assign({}, subMenuStyle, {
            display: "none"
        }))
        props.history.push(route)
    }

    function handleClickTab(item) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        let ele = subMenuLi[`li_${item.id}`]
        let widthOffset = getScreenWidth() - getElemWidth(ele)
        let offsetLeft = getOffsetLeft(ele) - widthOffset / 2
        ul.current.scrollLeft = offsetLeft
        if (item.tRoute) {
            setCurrentId(item.id.toString())
            props.history.push(item.tRoute)
        } else {
            setSubMenuStyle({
                display: "block",
                top: ele.getBoundingClientRect().bottom,
                left: ele.getBoundingClientRect().left
            })
        }
    }

    function getElemWidth(elem) {
        return elem.getBoundingClientRect().width
    }

    function getOffsetLeft(elem) {
        return elem.offsetLeft // 相对于父节点的距离
    }

    function getScreenWidth() {
        return document.body.clientWidth
    }

    return <div className="tab_layout">
        <ul ref={ul} id="tab_ul">
            {createTabItem(props.tabList)}
        </ul>
    </div>
}

export default TabLayout
